import { RelodeApiError } from "@relode/core";
import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";

import { CandidateDetails } from "../../../../../shared/types";

enum names {
    LOAD_CANDIDATE = "LOAD_CANDIDATE",
    LOAD_CANDIDATE_SUCCESS = "LOAD_CANDIDATE_SUCCESS",
    LOAD_CANDIDATE_FAILURE = "LOAD_CANDIDATE_FAILURE",
}

export default names;

export const creators = {
    loadCandidate: () => createAction(names.LOAD_CANDIDATE),
    loadCandidateSuccess: (candidate: CandidateDetails) =>
        createAction(names.LOAD_CANDIDATE_SUCCESS, {
            candidate,
        }),
    loadCandidateFailure: (apiError: RelodeApiError) =>
        createAction(names.LOAD_CANDIDATE_FAILURE, { apiError }),
};

export type ClientPublicCandidateActionTypes = ActionsUnion<typeof creators>;
